import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';

import { IonicModule } from '@ionic/angular';

import { ToggleGroupMembersPage } from './toggle-group-members.page';

const routes: Routes = [
  {
    path: '',
    component: ToggleGroupMembersPage
  }
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    RouterModule.forChild(routes)
  ],
  declarations: [ToggleGroupMembersPage]
})
export class ToggleGroupMembersPageModule {}
